<div class="d-flex flex-column">
  @if (showHeader) {
  <div class="d-flex align-items-center justify-content-end heading-container w-100 position-relative">
    <h4 class="heading position-absolute">{{ headerTitle }}</h4>
    <filter filterText="Visning" [filterData]="templateFilters" leftRightPosition="filter-position-right" (filterChange)="onFilterChange()" margin="right"></filter>
  </div>
  }
  <div class="calendar-outer-container">
    <div class="calendar-inner-container">
      @if (displayPrevButton) {
      <span mwlCalendarPreviousView [view]="view" [(viewDate)]="viewDate" (viewDateChange)="viewDateChanged($event)" style="cursor: pointer; padding: 0 8px;">
        <img src="../../../../assets/date_left.svg" alt="date left" />
      </span>
      } @else {
      <span style="padding: 0 8px; opacity: 0.2;">
        <img src="../../../../assets/date_left.svg" alt="date left" />
      </span>
      }
      <span class="date ">
        {{ viewDate | calendarDate : view + "ViewTitle" : "da" }}
      </span>
      @if(displayNextButton){
      <span mwlCalendarNextView [view]="view" [(viewDate)]="viewDate" (viewDateChange)="viewDateChanged($event)" style="cursor: pointer;padding: 0 8px;">
        <img src="../../../../assets/date_right.svg" alt="date right" />
      </span>
      } @else {
      <span style="padding: 0 8px; opacity: 0.2;">
        <img src="../../../../assets/date_right.svg" alt="date right" />
      </span>
      }
    </div>
    @if (calenderEvents$ | async; as calenderEvents) {
    <mwl-calendar-month-view [viewDate]="viewDate" [events]="calenderEvents" [locale]="locale" (dayClicked)="dayClicked($event.day)" (eventClicked)="eventClicked($event.event)" [cellTemplate]="customEventTemplate" [weekStartsOn]="1" (beforeViewRender)="onBeforeViewRender($event)">
    </mwl-calendar-month-view>
    }
    <ng-template #customEventTemplate let-day="day" let-openDay="openDay" let-locale="locale" let-tooltipPlacement="tooltipPlacement" let-highlightDay="highlightDay" let-unhighlightDay="unhighlightDay" let-eventClicked="eventClicked" let-tooltipTemplate="tooltipTemplate" let-tooltipAppendToBody="tooltipAppendToBody" let-tooltipDelay="tooltipDelay" let-trackByEventId="trackByEventId" let-validateDrag="validateDrag">
      <div style="flex: 1 0 auto;display:flex;flex-direction: column;" [ngClass]="{
      'lock-period': !day.meta.allow,
    }">
        <div class="cal-cell-top" [attr.aria-label]="
          { day: day, locale: locale } | calendarA11y : 'monthCell'
        ">

          <span class="cal-day-badge cal-day-weeknumber cal-cell-top-item" *ngIf="isMonday(day.date)">Uge {{
            getISOWeek(day.date)
          }}</span>
          <span style="flex:1 1 auto;"></span>
          @if (day.meta.showLockIcon) {
          <span class="cal-cell-top-item">
            <mat-icon style="height:16px;width:16px;font-size:16px;vertical-align: top;" [matTooltip]="'Låst: ' + day.meta.reason">lock</mat-icon>
          </span>
          }
          <span class="cal-day-number">{{
            day.date | calendarDate : "monthViewDayNumber" : locale
          }}</span>

        </div>
        <div class="cal-events" *ngIf="day.events.length > 0">
          @for (event of day.events; track event.id) {

          <div class="cal-event" [ngClass]="event?.cssClass" (mouseenter)="highlightDay.emit({ event: event })" (mouseleave)="unhighlightDay.emit({ event: event })" [mwlCalendarTooltip]="
            event.title | calendarEventTitle : 'monthTooltip' : event
          " [tooltipPlacement]="tooltipPlacement" [tooltipEvent]="event" [tooltipTemplate]="tooltipTemplate" [tooltipAppendToBody]="tooltipAppendToBody" [tooltipDelay]="tooltipDelay" mwlDraggable [class.cal-draggable]="event.draggable" dragActiveClass="cal-drag-active" [dropData]="{ event: event, draggedFrom: day }" [dragAxis]="{ x: event.draggable, y: event.draggable }" [validateDrag]="validateDrag" [touchStartLongPress]="{ delay: 300, delta: 30 }" (mwlClick)="eventClicked.emit({ event: event, sourceEvent: $event })">
            <div style="display: flex;align-items: center;">
              @if (event.meta.type == 'Comment') {
              <mat-icon class="event-type-icon">comment</mat-icon>
              }
              @else if (event.meta.type == 'event') {
              <mat-icon class="event-type-icon">event</mat-icon>
              }
              @else if (event.meta.type == 'sendout') {
              @if (event.meta.status == SendoutStatus.Draft) {
              <mat-icon class="event-type-icon">drafts</mat-icon>
              } @else if (event.meta.status == SendoutStatus.AwaitingApproval) {
              <mat-icon class="event-type-icon">pending_actions</mat-icon>
              } @else if (event.meta.status == SendoutStatus.Rejected) {
              <mat-icon class="event-type-icon" style="color:#d43a42">unsubscribe</mat-icon>
              } @else if (event.meta.status == SendoutStatus.Approved) {
              <mat-icon class="event-type-icon">mark_email_read</mat-icon>
              } @else {
              <mat-icon class="event-type-icon">mail</mat-icon>
              }

              }
              {{ event.title }}

            </div>
          </div>
          }
        </div>
      </div>
    </ng-template>
  </div>
  @if (showLegend) {
  <app-calendar-helpers></app-calendar-helpers>
  }
</div>
